<div
*ngIf="isDialogVisible"
  class="z-[1000] fixed inset-0 bg-black/50 backdrop-blur-xs flex items-center justify-center"
>
  <div class="bg-white w-fit min-w-[390px] xl:min-w-[415px] 2xl:min-w-[440px] 3xl:min-w-[480px] max-w-[90vw] rounded-xl shadow-xl overflow-hidden relative">
    <!-- Header -->
    <div class="px-7 pt-5 pb-6 xl:px-8 xl:pt-5 xl:pb-7 2xl:px-10 2xl:pt-6 2xl:pb-8 3xl:px-11 3xl:pt-7 3xl:pb-9">
      <div class="flex items-start justify-between gap-3.5 xl:gap-4 2xl:gap-5 3xl:gap-6">
        <h2 class="text-[0.92rem] xl:text-[1rem] 2xl:text-[1.1rem] 3xl:text-[1.2rem] font-[MontserratBold] text-red-700 leading-tight">
          Sessione scaduta
        </h2>
     <!--   <svg
          (click)="logout()"
          class="cursor-pointer w-[18px] h-[18px] xl:w-[20px] xl:h-[20px] 2xl:w-[22px] 2xl:h-[22px] 3xl:w-[26px] 3xl:h-[26px] shrink-0"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.1471 18.3525C19.2024 18.404 19.2467 18.4661 19.2775 18.5351C19.3082 18.6041 19.3248 18.6786 19.3261 18.7541C19.3274 18.8296 19.3135 18.9047 19.2852 18.9747C19.2569 19.0447 19.2148 19.1084 19.1614 19.1618C19.108 19.2152 19.0444 19.2573 18.9743 19.2856C18.9043 19.3139 18.8293 19.3278 18.7537 19.3265C18.6782 19.3251 18.6037 19.3086 18.5347 19.2778C18.4657 19.2471 18.4036 19.2028 18.3521 19.1475L11.9996 12.7959L5.64714 19.1475C5.54051 19.2469 5.39947 19.301 5.25375 19.2984C5.10802 19.2958 4.96898 19.2368 4.86592 19.1337C4.76286 19.0307 4.70383 18.8916 4.70126 18.7459C4.69869 18.6002 4.75278 18.4591 4.85214 18.3525L11.2037 12L4.85214 5.64751C4.75278 5.54088 4.69869 5.39984 4.70126 5.25411C4.70383 5.10839 4.76286 4.96935 4.86592 4.86629C4.96898 4.76323 5.10802 4.7042 5.25375 4.70163C5.39947 4.69905 5.54051 4.75315 5.64714 4.85251L11.9996 11.2041L18.3521 4.85251C18.4588 4.75315 18.5998 4.69905 18.7455 4.70163C18.8913 4.7042 19.0303 4.76323 19.1334 4.86629C19.2364 4.96935 19.2955 5.10839 19.298 5.25411C19.3006 5.39984 19.2465 5.54088 19.1471 5.64751L12.7956 12L19.1471 18.3525Z"
            fill="#B91C1C"
          />
        </svg> -->
      </div>

      <div class="border-t border-gray-100 mt-3.5 mb-5 xl:mt-4 xl:mb-6 2xl:mt-5 2xl:mb-7 3xl:mt-6 3xl:mb-8"></div>

      <p class="text-[0.66rem] xl:text-[0.72rem] 2xl:text-[0.82rem] 3xl:text-[0.9rem] text-gray-500 text-center">
        La tua sessione è scaduta. Effettua nuovamente l'accesso.
      </p>
    </div>

    <!-- Divider -->
    <div class="border-t border-gray-100"></div>

    <!-- Footer -->
    <div class="flex items-center justify-center gap-5 px-7 py-5 xl:gap-6 xl:px-8 xl:py-5 2xl:gap-7 2xl:px-10 2xl:py-6 3xl:gap-8 3xl:px-11 3xl:py-7">
      <button
        class="bg-red-700 hover:bg-red-800 text-white text-[0.71rem] xl:text-[0.75rem] 2xl:text-[0.82rem] 3xl:text-[0.89rem] font-semibold py-2 px-5 xl:py-2 xl:px-5 2xl:py-2.5 2xl:px-6 3xl:py-3 3xl:px-7 rounded-md transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
        (click)="logout()"
      >
        OK
      </button>
    </div>
  </div>
</div>